














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Babysitter, Balance } from '@/interfaces/Models';
import { Debounce } from 'lodash-decorators';
import { Action, Getter } from 'vuex-class';

@Component
export default class BabysitterVacationsCalendar extends Vue {
  @Prop() dialog!: boolean;
  @Prop() selectedBabysitter!: number | null;

  public loading: boolean = false;
  public dates: any[] = [];
  public value: string = new Date().toISOString().substr(0, 10);
  public calendar: any = null;

  public close() {
    this.$emit('update:dialog', !this.dialog);
    this.loading = true;
    this.dates = [];
  }

  public setPayload(data: any[]) {
    const events: any[] = [];
    data.forEach((vacation, i) => {
      if (vacation.starts_at && vacation.ends_at) {
        events.push({
          name: `Vacation #${i + 1}`,
          start: vacation.starts_at.substr(0, 10),
          end: vacation.ends_at.substr(0, 10),
          timed: false,
        });
      }
    });

    events.sort((a, b) => (a.start > b.start ? 1 : -1));
    this.dates = events;

    const today = new Date().toISOString().substr(0, 10);
    const upcoming = this.dates.find((d) => (d.end || d.start) >= today);

    if (upcoming) {
      this.value = upcoming.start;
    } else if (this.dates.length > 0) {
      this.value = this.dates[this.dates.length - 1].start;
    } else {
      this.value = today;
    }
  }

  public async showBabysitterCalendar() {
    this.loading = true;
    this.dates = [];
    this.value = new Date().toISOString().substr(0, 10);

    axios
      .get(
        api.path('v1.admin.babysitters.vacations', {
          id: this.selectedBabysitter,
        })
      )
      .then((res) => {
        this.setPayload(res.data.data);
      })
      .finally(() => {
        this.loading = false;
        this.$nextTick(() => {
          if (this.$refs.calendar) {
            this.calendar = this.$refs.calendar;
          }
        });
      });
  }

  public update() {
    if (this.$refs.calendar) {
      this.calendar = this.$refs.calendar;
    }
  }

  @Watch('dialog')
  onDialogOpen(opened: any) {
    if (opened && this.selectedBabysitter) {
      this.showBabysitterCalendar();
    }
  }
}
